import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { BrowserRouter } from 'react-router-dom';
import App from './components/App';
import './index.css';
import commonsTheme from './theme/commonsTheme';

import ContentContextProvider from './contexts/Content';

const GlobalStyle = createGlobalStyle`
  ${({ theme }) => `
    body {
      // background: ${theme.colors.neutralColors.charcoal};
    }
  `}
`;

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={commonsTheme}>
        <ContentContextProvider>
          <GlobalStyle />
          <App />
        </ContentContextProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);
